import { AnyAction, createReducer } from '@reduxjs/toolkit';

import {
	SENSOR_TYPE_LIST,
	SENSOR_TYPE_UNITS_MAP,
} from '@innovyze/shared-utils';
import { SensorTypesStoreState } from '@Types/sensorTypes.types';

export const initialState: SensorTypesStoreState = {
	types: SENSOR_TYPE_LIST,
	units: SENSOR_TYPE_UNITS_MAP,
};

interface SensorTypesReducer {
	[x: string]: (
		state: SensorTypesStoreState,
		action: AnyAction,
	) => SensorTypesStoreState | undefined;
}

const reducer: SensorTypesReducer = {};

export default createReducer(initialState, reducer);
